export class Modal extends HTMLElement {
  constructor(_col, _type) {
    super();
    this.container = document.getElementById("modal-content");
    this._attachEventHandlers();
  }
  get visible() {
    return this.hasAttribute("visible");
  }

  static get observedAttributes() {
    return ["collection-handle","visible","title","modal-type"];
  }

  get collectionHandle() {
    return this.getAttribute("collection-handle");
  }
  get modalType() {
    return this.getAttribute("modal-type");
  }

  set visible(value) {
    if (value) {
      this.setAttribute("visible", "");
    } else {
      this.removeAttribute("visible");
    }
  }

  openCollectionModal() {
    this._render();
    this.visible = true;
    const body = document.querySelector("body");
    body.classList.add("modal-open");
    this.dispatchEvent(new CustomEvent("open"));
  }

  closeCollectionModal() {
    this._unRender();
    this.visible = false;
    const body = document.querySelector("body");
    body.classList.remove("modal-open");
    this.dispatchEvent(new CustomEvent("close"));
  }

  connectedCallback() {
    const closeEvent = new Event('close-modal', { bubbles: true });
    const modal = document.querySelector('x-modal');
    modal.addEventListener('close-modal', (e) => { this.closeCollectionModal() }, false)
  }

  get title() {
    return this.getAttribute("title");
  }

  set title(value) {
    this.setAttribute("title", value);
  }


  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "visible") {
      if (newValue === null) {
        this.querySelector(".wrapper").classList.remove("visible");
        this._unRender();
        this.dispatchEvent(new CustomEvent("close"));
      } else {
        this.swiper = this._generateSwiper();
        this.swiper.setAttribute("collection-handle", this.collectionHandle);
        this.swiper.setAttribute("modal-type", this.modalType);
        const swiperContainer = this.container.querySelector(".content");
        swiperContainer.appendChild(this.swiper);
        this.dispatchEvent(new CustomEvent("open"));
      }
    }
  }
  _unRender() {
    this.visible = false;
  }

  _generateSwiper() {
    return document.createElement("x-swiper");
  }

  _render() {
    const wrapperClass = this.visible ? "wrapper visible" : "wrapper";
    this.container.innerHTML = `
          <div class='${wrapperClass}'>
              <div class='content'>
              </div>
          </div>`;
    this.appendChild(this.container);
    this.querySelector(".wrapper").classList.add("visible");
  }

  _attachEventHandlers() {
    document.body.addEventListener(
      "keydown",
      function (e) {
        // console.log(e);
        if (e.key == "Escape") {
          this.closeCollectionModal();
        }
      }.bind(this)
    );

    document.body.addEventListener('click', function(e){
      if (document.querySelector('.content') && document.querySelector('.content').contains(e.target)){
        if (e.target.querySelector('.cancel')) {
          this.closeCollectionModal();
        }
      } else{
        this.closeCollectionModal();
      }

    }.bind(this));

  }
}


